import '../LogisticServiceListingCard/LogisticServiceListingCard.scss';

const LogisticsServiceListingCardSkeletonLoader = () => {
  return (
    <div className="LogisticServiceListingCard">
      <div className="LogisticServiceCardContainer">
        <div className="LogisticServiceColumn country">
          <div className="value animationLoader" />
        </div>
        <div className="LogisticServiceColumn business">
          <div className="value animationLoader" />
        </div>
        <div className="LogisticServiceColumn id">
          <div className="value animationLoader" />
        </div>
        <div className="LogisticServiceColumn origin">
          <div className="value animationLoader" />
        </div>
        <div className="LogisticServiceColumn destination">
          <div className="value animationLoader" />
        </div>
        <div className="LogisticServiceColumn state">
          <div className="value animationLoader" />
        </div>
        <div className="LogisticServiceColumn services">
          <div className="value animationLoader" />
        </div>
        <div className="LogisticServiceColumn comments">
          <div className="value animationLoader" />
        </div>
        <div className="LogisticServiceColumn notes">
          <div className="value animationLoader" />
        </div>
        <div className="LogisticServiceColumn provider">
          <div className="value animationLoader" />
        </div>
        <div className="LogisticServiceColumn price">
          <div className="value animationLoader" />
        </div>
      </div>
    </div>
  );
};

export default LogisticsServiceListingCardSkeletonLoader;
